import {LIBRARY_SAH, LIBRARY_UMD} from "./constants";
import loadSAH from "./utils/loadSAH";
import loadUMD from "./utils/loadUMD";

export default class LibraryManager {
    constructor() {
        this.register = {};
    }

    get(id) {
        return this.register[id];
    }

    add(library) {
        this.register[library.id] = library;
    }

    remove(id) {
        delete this.register[id];
    }

    async needs(id, contents) {
        // get the library config
        const library = this.get(id);

        // check format
        if (!library.source) {
            throw Error(`Missing source data for library ${id}`);
        }

        // according to the type of library, we will load the content accordingly
        switch (library.source.type) {
            case LIBRARY_SAH:
                await loadSAH(library, contents);
                break;
            case LIBRARY_UMD:
                await loadUMD(library);
                break;
            default:
                throw Error(`Library type ${library.source.type} not handled for ${id}`);
        }
    }
}
